module.exports = __webpack_public_path__ + "static/media/phone.ac755089.svg";